angular.module('app.factories').factory('ToastService', ($mdToast) => {
    const delay = 6000;
    const position = 'right bottom';
    const action = 'ok';

    return {
        info(content) {
            return $mdToast.show($mdToast.simple().content(content).position(position).theme('info').action(action).hideDelay(delay));
        },
        success(content) {
            return $mdToast.show($mdToast.simple().content(content).position(position).theme('success').action(action).hideDelay(delay));
        },
        error(content) {
            return $mdToast.show($mdToast.simple().content(content).position(position).theme('error').action(action).hideDelay(delay));
        },
    };
});
